import dayjs from 'dayjs';
let _id = 0;

const categories = [
  { id: 1, name: 'Продукты компании' },
  { id: 2, name: 'Материалы по маркетингу' },
  { id: 3, name: 'Конкуренты' },
  { id: 4, name: 'Управление персоналом' },
];

const fileTypes = [
  { id: 1, name: 'Презентация', icon: 'file-powerpoint', style: 'is-orange' },
  { id: 2, name: 'PDF', icon: 'file-pdf', style: 'is-red' },
  { id: 3, name: 'Word', icon: 'file-word', style: 'is-blue' },
];

const taskStatuses = [
  { id: 1, title: 'Новая', icon: 'star-circle-outline', color: 'is-cyan' },
  { id: 2, title: 'В процессе', icon: 'circle-slice-5', color: 'is-warning' },
  { id: 3, title: 'Выполнено', icon: 'checkbox-marked-circle-outline', color: 'is-light' },
];

const rand = max => Math.floor(Math.random() * max);

const task = (document, status, deadline, isComplete = false, test = null) => ({
  id: ++_id,
  document,
  test,
  status,
  isComplete,
  deadline: dayjs(deadline).toDate(),
});

const doc = (name, custom) => {
  const isNew = (custom && custom.isNew) || false;
  const isTargetSuccess = (custom && custom.isTargetSuccess) || false;
  const progress = isNew ? 0 : isTargetSuccess ? 100 : rand(2) ? rand(100) : rand(2) ? 0 : 100;
  return {
    id: ++_id,
    name,
    progress,
    isComplete: progress === 100,
    isUnread: progress === 0,
    category: categories[rand(4)],
    file: fileTypes[rand(3)],
    comments: isNew ? 0 : rand(30),
    newComments: isNew ? 0 : rand(3) ? 0 : rand(3),
    ...custom,
  };
};

const isNew = true;
const isTarget = true;
const isTargetSuccess = true;
const isComplete = true;

const docs = [
  doc('Учебный материал по продуктам компании', { isNew, isTarget }),
  doc('Медикаментозная коррекция рН мочи при мочекаменной болезни', { isNew, isTarget }),
  doc('Работа с договорами', { isTargetSuccess }),
  doc('Бренд как основа успешного современного бизнеса'),
  doc('Использование аромакологии в PR'),
  doc('Психология маркетинга: Учебное пособие'),
  doc('Реклама качества & Качество рекламы'),
  doc('Управление персоналом: Учебник'),
  doc('Организационная культура'),
  doc('Трудовое право в вопросах и ответах'),
  doc('Бренд как основа успешного современного бизнеса'),
  doc('Использование аромакологии в PR'),
  doc('Психология маркетинга: Учебное пособие'),
  doc('Реклама качества & Качество рекламы'),
  doc('Управление персоналом: Учебник'),
  doc('Организационная культура'),
  doc('Трудовое право в вопросах и ответах'),
  doc('Бренд как основа успешного современного бизнеса'),
  doc('Использование аромакологии в PR'),
  doc('Психология маркетинга: Учебное пособие'),
  doc('Реклама качества & Качество рекламы'),
  doc('Управление персоналом: Учебник'),
  doc('Организационная культура'),
  doc('Трудовое право в вопросах и ответах'),
];

const tests = [{ name: ' Тесты по Уриклару' }];

const tasks = [
  task(docs[0], taskStatuses[1], '2020-04-20'),
  task(docs[2], taskStatuses[2], '2020-06-05', isComplete),
  task(docs[1], taskStatuses[2], '2020-06-05', isComplete),
  task(docs[3], taskStatuses[1], '2020-06-05'),
  task(docs[6], taskStatuses[0], '2020-06-05'),
  task(null, taskStatuses[0], '2020-07-05', !isComplete, tests[0]),
  task(docs[4], taskStatuses[0], '2020-07-10'),
  task(docs[5], taskStatuses[0], '2020-07-10'),
];

export default {
  categories,
  fileTypes,
  taskStatuses,
  docs,
  tasks,
};
